import React from 'react';
import { observer } from 'mobx-react';
import { IAddressProps } from './index';

export const AddressCepFormat = observer((props: IAddressProps) => {
  const { addressInputs } = props;

  return (
    <div>
      {addressInputs.zipCodeInput}
      {addressInputs.addressInput}

      <div className={'container-three-columns'}>
        {addressInputs.streetNumberInput}
        {addressInputs.withoutNumberCheckbox}
        {addressInputs.complementInput}
      </div>

      {addressInputs.neighborhoodInput}

      <div className={'container-three-columns'}>
        {addressInputs.cityInput}
        {addressInputs.stateDropDownInput}
        {addressInputs.countryInput}
      </div>
    </div>
  );
});
